import axios from "axios";
import routes from "../app/routes";

const prepareFormDataForSend = (values) => {
  let formData = {
    title: values.title,
    category_type: values.category_type,
  };
  return formData;
};

export const topicCategoryActions = {
  loadTopicCategories: (dispatch) => {
    axios.get(routes.api.topic_categories.index).then((resp) => {
      dispatch({
        type: "loadTopicCategories",
        topicCategories: resp.data.data,
      });
    });
  },
  saveTopicCategory: (
    dispatch,
    categoryId,
    values,
    successCallback,
    errorCallback
  ) => {
    if (categoryId == 0) {
      axios
        .post(routes.api.topic_categories.create, {
          ...prepareFormDataForSend(values),
        })
        .then((resp) => {
          successCallback();
        })
        .catch((error) => {
          errorCallback(error.response.data);
        });
    } else {
      axios
        .put(routes.api.topic_categories.update(categoryId), {
          ...prepareFormDataForSend(values),
        })
        .then((resp) => {
          successCallback();
        })
        .catch((error) => {
          errorCallback(error.response.data);
        });
    }
  },
  moveCategory: (dispatch, list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    dispatch({
      type: "moveCategory",
      topicCategories: result,
    });

    axios
      .post(routes.api.topic_categories.sort, {
        categories: result.map((item, index) => {
          return { id: item.id, index: index };
        }),
      })
      .then((resp) => {});
  },
  deleteTopicCategory: (dispatch, categoryId, callback) => {
    axios
      .delete(routes.api.topic_categories.destroy(categoryId))
      .then((resp) => {
        callback();
      });
  },
  showCreateForm: (dispatch) => {
    dispatch({ type: "showModal", currentTopicCategory: null });
  },
  showEditForm: (dispatch, row) => {
    dispatch({ type: "showModal", currentTopicCategory: row });
  },
  hideModal: (dispatch) => {
    dispatch({ type: "hideModal" });
  },
};
